import { render, staticRenderFns } from "./GlobalSalesCard.vue?vue&type=template&id=465fa506&scoped=true&"
import script from "./GlobalSalesCard.vue?vue&type=script&lang=js&"
export * from "./GlobalSalesCard.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSalesCard.vue?vue&type=style&index=0&id=465fa506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465fa506",
  null
  
)

export default component.exports